<template lang="pug">
section.rating
  .content
    RatingGroup(
      v-for="(group_info, group_name) in gropus",
      :key="group_name",
      :type="group_name",
      :places="group_info.places",
      :ratingData="ratingData"
    )
</template>

<script>
import RatingGroup from "./RatingGroup";

export default {
  name: "Rating",
  components: {
    RatingGroup,
  },
  data() {
    return {
      ratingData: {},
      gropus: {
        gold: {
          places: [1],
        },
        silver: {
          places: [2, 3],
        },
        bronze: {
          places: [4, 5, 6, 7, 8, 9, 10],
        },
      },
    }
  },

  created() {
    this.getRatingData();
  },

  methods: {
    getRatingData() {
      this.$api.laAccountService
        .getEpicGateFirstClear()
        .run()
        .then(response => {
          if (!response.data.error) {
            this.ratingData = this.getFormattedData(response.data.result);
          }
        });
    },
    getFormattedData(origin_data) {
      let formatted_data = {};

      origin_data.map(item => {
        if(!formatted_data.hasOwnProperty(item.rank)) {
          formatted_data[item.rank] = {};
          formatted_data[item.rank].date = item.clearDate;
          formatted_data[item.rank].list = [];
        }

        formatted_data[item.rank].list.push(item);
      })

      return formatted_data;
    },
  },
};
</script>
